<template>
  <div id="user">
    <p class="title"><label @click="$router.push('/user/home')" style="font-size:16px;ont-weight:900;color:green;">我的 / </label>浏览记录</p>
    <div class="common-search-box">
      <div>
        <div>
          <span>商品名称</span>
          <el-input placeholder="商品名称" v-model="query.commodity.name" size="small" style="width: 240px"></el-input>
        </div>
        <div>
          <span>货号</span>
          <el-input placeholder="原始货号" v-model="query.commodity.atrNo" size="small" style="width: 240px"></el-input>
        </div>
      </div>
      <div>
        <button class="common-btn sureBtn" @click="getCommodites">查询</button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" tooltip-effect="dark">
      <el-table-column align="right" prop="name" label width="100">
        <template slot-scope="scope">
          <router-link
            :to="{path:`/goodsdetail?id=${scope.row.commodity.id}&groupNo=${scope.row.commodity.groupNo||''}`}"
          >
            <img
              :src="scope.row.commodity.defaultImage"
              style="max-width: 100px;max-height: 60px;cursor: pointer;"
            />
          </router-link>
        </template>
      </el-table-column>
      <el-table-column align="left" show-overflow-tooltip  prop="name" label="商品" min-width="4">
        <template slot-scope="scope">
          <router-link
            :to="{path:`/goodsdetail?id=${scope.row.commodity.id}&groupNo=${scope.row.commodity.groupNo||''}`}"
          >{{scope.row.commodity.name}}</router-link>
        </template>
      </el-table-column>
      <el-table-column align="center" show-overflow-tooltip prop="commodity.atrNo" label="原始货号" min-width="2"></el-table-column>
      <el-table-column align="center" show-overflow-tooltip prop="commodity.categoriesStr" label="分类" min-width="3"></el-table-column>
      <el-table-column align="center" show-overflow-tooltip prop="commodity.brandStr" label="品牌" min-width="2"></el-table-column>
      <el-table-column align="center" prop="commodity.marketPrice" label="市场价(元)" min-width="2"></el-table-column>
      <!-- <el-table-column align="center" prop="commodity.collectivePrice" label="集采价(元)" min-width="2"></el-table-column> -->
      <el-table-column prop="id" label="操作" min-width="3">
          <template slot-scope="scope">
            <button class="common-btn common-btn-h1" slot="reference" @click="browseToMyAttention(scope.row.id)" >关注</button>
            <el-popconfirm
              title="确定删除改关注?"
              @confirm="deleteBrowse(scope.row.id)"
            >
              <button class="common-btn" slot="reference" >删除</button>
            </el-popconfirm>
          </template>
        </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: right;margin-top: 12px"
      @size-change="pageSizeChange"
      @current-change="pageChange"
      :current-page.sync="query.pageNo"
      :page-sizes="[4, 6, 8, 10]"
      :page-size="query.pageSize"
      layout="sizes, prev, pager, next"
      :total="query.total"
    ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getBrowseList, deleteMyBrowse, browseToMyAttention } from "@/js/api";
export default {
  name: "browse",
  data() {
    return {
      tableData: [],
      query: {
        commodity: {name:'', atrNo:''},
        pageNo: 1,
        pageSize: 10
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    pageChange: function(page) {
      this.query.pageNo = page;
      this.getData();
    },
    pageSizeChange: function(size) {
      this.query.pageSize = size;
      this.getData();
    },
    getData() {
        console.info(this.query)
      getBrowseList(this.query).then(res => {
        if (res.code == 0) {
          const list = res.result.records || [];
          this.query.total = res.result.total;
          this.tableData = list;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getCommodites(){
      this.getData()
    },
    browseToMyAttention(id){
      browseToMyAttention({
        id: id
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    deleteBrowse(id){
      deleteMyBrowse({
        id: id
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getData();
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>

</style>
